<template>
  <div>
    <MainToolbar v-bind:notif="notif" v-bind:objDialog="objDialog"></MainToolbar>
    <transition
      name="router-anim"
      enter-active-class="animated fadeInDown"
      leave-active-class="animated fadeOutDown"
    ></transition>
    <v-content>
      <v-container fluid>
        <v-layout row wrap>
          <v-flex md2 xs12 ma-1>
            <v-autocomplete
              ref="LogTypes"
              :items="configKeys"
              v-model="selectedLogType"
              label="Log Type"
              item-text="ConfigurationKey"
              return-object
              clearable
              @change="searchFilter"
            ></v-autocomplete>
          </v-flex>
          <v-flex md2 xs12 ma-1>
            <v-autocomplete
              ref="Agents"
              v-model="selectedAgent"
              :items="agents"
              item-text="Name"
              label="Agent ID"
              return-object
              clearable
              @change="searchFilter"
            ></v-autocomplete>
          </v-flex>
          <v-flex md2 xs12 ma-1>
            <v-menu
              ref="menu1"
              v-model="menu1"
              :close-on-content-click="true"
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="dateFrom"
                  label="Date From"
                  readonly
                  hint="YYYY/MM/DD format"
                  persistent-hint
                  prepend-icon="event"
                  clearable
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="dateFrom" no-title @input="menu1 = false;"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex md2 xs12 ma-1>
            <v-menu
              ref="menu2"
              v-model="menu2"
              :close-on-content-click="true"
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="dateTo"
                  label="Date To"
                  readonly
                  hint="YYYY/MM/DD format"
                  persistent-hint
                  prepend-icon="event"
                  clearable
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="dateTo" no-title @input="menu2 = false;"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex md2 xs12 ma-1>
            <v-checkbox
              v-model="checkbox"
              @change="CheckFetchAgentEvents(checkbox)"
              label="Fetch from Live Agent"
            ></v-checkbox>
          </v-flex>
          <v-flex md1 xs12 ma-1>
            <v-btn outline color="green" class="white--text" @click="refreshLogs()">
              REFRESH
              <v-icon right dark>refresh</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="data"
          :pagination.sync="pagination"
          :rows-per-page-items="[10, 20, 35]"
          class="elevation-1"
        >
          <template slot="headers" slot-scope="props">
            <tr>
              <th
                v-for="header in props.headers"
                :key="header.text"
                :class="[
                  'column',
                  header.sortable == false ? '' : 'sortable',
                  pagination.descending ? 'desc' : 'asc',
                  header.value === pagination.sortBy ? 'active' : ''
                ]"
                @click="header.sortable != false && changeSort(header.value)"
              >
                <v-icon small v-show="header.sortable != false">arrow_upward</v-icon>
                {{ header.text }}
              </th>
            </tr>
          </template>
          <template slot="items" slot-scope="props">
            <td class="text-xs-center">{{ props.item.agent_id }}</td>
            <td class="text-xs-center">{{ props.item.tenant_id }}</td>
            <td class="text-xs-center">{{ props.item.log_type }}</td>
            <td class="text-xs-center">
              <v-tooltip bottom offset-overflow max-width="700">
                <template v-slot:activator="{ on }">
                  <span v-on="on">
                    {{ formatViewString(props.item.data, 50) }}
                  </span>
                </template>
                <span>{{ formatViewString(props.item.data, 1200) }}</span>
              </v-tooltip>
            </td>
            <td class="text-xs-center">{{ fromatDate(props.item.time) }}</td>
            <td class="text-xs-center">
              <v-tooltip bottom offset-overflow max-width="500">
                <template v-slot:activator="{ on }">
                  <span v-on="on">
                    {{ formatViewString(props.item.Description, 50) }}
                  </span>
                </template>
                <span>{{ formatViewString(props.item.Description, 400) }}</span>
              </v-tooltip>
            </td>
            <td class="justify-center layout px-0">
              <v-btn
                fab
                small
                dark
                color="green"
                class="white--text"
                @click="viewAgentLog(props.item)"
              >
                <i class="material-icons">visibility</i>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-container>
      <loading :active.sync="loading" :can-cancel="false" :is-full-page="true"></loading>
    </v-content>
    <div class="text-center">
      <v-dialog v-model="dialog" width="80%">
        <v-card>
          <v-card-title class="headline">LOG DETAIL</v-card-title>

          <v-card-text>
            <v-container>
              <v-divider style="margin-bottom:10px;"></v-divider>
              <v-layout row wrap>
                <v-flex sm4 md2 xs12>
                  <strong>AGENT ID</strong>
                </v-flex>
                <v-flex sm8 md10 xs12>
                  <span>{{ dialogData.agent_id }}</span>
                </v-flex>
              </v-layout>
              <v-divider style="margin:10px 0;"></v-divider>
              <v-layout row wrap>
                <v-flex sm4 md2 xs12>
                  <strong>TENANT ID</strong>
                </v-flex>
                <v-flex sm8 md10 xs12>
                  <span>{{ dialogData.tenant_id }}</span>
                </v-flex>
              </v-layout>
              <v-divider style="margin:10px 0;"></v-divider>
              <v-layout row wrap>
                <v-flex sm4 md2 xs12>
                  <strong>LOG TYPE</strong>
                </v-flex>
                <v-flex sm8 md10 xs12>
                  <span>{{ dialogData.log_type }}</span>
                </v-flex>
              </v-layout>
              <v-divider style="margin:10px 0;"></v-divider>
              <v-layout row wrap>
                <v-flex sm4 md2 xs12>
                  <strong>DATA</strong>
                </v-flex>
                <v-flex sm8 md10 xs12>
                  <span>{{ dialogData.data }}</span>
                </v-flex>
              </v-layout>
              <v-divider style="margin-top:10px;"></v-divider>
              <v-layout row wrap>
                <v-flex sm4 md2 xs12>
                  <strong>Description</strong>
                </v-flex>
                <v-flex sm8 md10 xs12>
                  <span>{{ dialogData.Description }}</span>
                </v-flex>
              </v-layout>
              <v-divider style="margin-top:10px;"></v-divider>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="dialog = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>
<script>
import DataService from "@/services/data-service";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import MainToolbar from "@/components/MainToolbar.vue";

const dataService = new DataService();
export default {
  name: "logs",
  props: [],
  components: {
    Loading,
    MainToolbar,
    DataService
  },
  data: vm => ({
    dateFrom: null,
    checkbox: false,
    menu1: false,
    dateTo: null,
    menu2: false,
    dateFormattedFrom: null, // vm.formatDateFrom(new Date().toISOString().substr(0, 10)),
    dateFormattedTo: null,
    objDialog: {
      dialog_title: "",
      dialog_body: "",
      btn_ok_text: "Ok",
      btn_cancel_text: "Cancel",
      show: false,
      result: undefined
    },
    loading: false,
    agents: [],
    selectedAgent: {},
    selectedLogType: {},
    selected: [],
    headers: [],
    data: [],
    logData: [],
    dialogData: [],
    configKeys: [],
    notif: {
      color: "success",
      message: "",
      show: false
    },
    pagination: {
      sortBy: "Data"
    },
    dialog: false
  }),
  computed: {
    // computedDateFormatted() {
    //   return this.formatDateFrom(this.dateFrom);
    // }
  },
  created() {
    const that = this;
    that.getLogs();
    that.getAgents();
    that.getLogsForDropDown();
    this.headers = [
      {
        text: "Agent ID",
        value: "agent_id",
        align: "left",
        width: "1%",
        visibility: "hidden-xs-only"
      },
      {
        text: "Tenant ID",
        value: "tenant_id",
        align: "left",
        width: "1%",
        visibility: "hidden-xs-only"
      },
      {
        text: "Log Type",
        value: "log_type",
        align: "left",
        width: "1%"
      },
      {
        text: "Data",
        value: "data",
        align: "left",
        width: "55% !important",
        visibility: "hidden-xs-only"
      },
      {
        text: "Date",
        value: "time",
        align: "left",
        width: "55% !important",
        visibility: "hidden-xs-only"
      },
      {
        text: "Description",
        value: "Description",
        align: "left",
        width: "55% !important",
        visibility: "hidden-xs-only"
      },
      {
        text: "View",
        value: "View",
        align: "left",
        width: "1%",
        visibility: "hidden-xs-only"
      }
    ];
  },
  watch: {
    dateFrom(val) {
      this.searchFilter();
    },
    dateTo(val) {
      this.searchFilter();
    }
  },
  methods: {
    refreshLogs() {
      const that = this;
      if (that.checkbox) that.CheckFetchAgentEvents(that.checkbox);
      else that.getLogs();
    },
    getLogs() {
      const that = this;
      dataService.getLogs().then(res => {
        if (res.length > 0) {
          that.data = res;
          that.logData = res;
          that.searchFilter();
        }
      });
    },
    getAgents() {
      const that = this;
      dataService.getAgentList().then(_agents => {
        that.agents = _agents;
      });
    },
    getLogsForDropDown() {
      const that = this;
      dataService.getConfigModules().then(resp => {
        const modules = resp || [];
        this.configKeys = [];
        if (modules.length > 0) {
          const logModule = modules.find(x => x.ModuleName === "Logs");
          const intervalModule = modules.find(
            x => x.ModuleName === "AgentIntervalSettings"
          );
          if (logModule && logModule.ModuleId > 0) {
            dataService.getConfigKeys(logModule.ModuleId).then(keys => {
              const rKeys = keys || [];
              rKeys.forEach(k => this.configKeys.push(k));
            });
          }
          if (intervalModule && intervalModule.ModuleId > 0) {
            dataService.getConfigKeys(intervalModule.ModuleId).then(keys => {
              const rKeys = keys || [];
              rKeys.forEach(k => this.configKeys.push(k));
            });
          }
        }
      });
    },
    searchFilter() {
      const that = this;
      const selectedLogType = that.selectedLogType
        ? that.selectedLogType.ConfigurationKey
        : undefined;
      const selectedAgent = that.selectedAgent
        ? that.selectedAgent.Name
        : undefined;
      const selectedDateFrom = that.dateFrom
        ? new Date(that.dateFrom.replace(/-/g, "/"))
        : undefined;
      const selectedDateTo = that.dateTo
        ? new Date(`${that.dateTo.replace(/-/g, "/")} 23:59:59`)
        : undefined;
      // eslint-disable-next-line
      let filteredLogs = that.logData;
      if (selectedLogType && filteredLogs && filteredLogs.length > 0) {
        filteredLogs = filteredLogs.filter(item => {
          if (item.log_type)
            if (item.log_type.toUpperCase() === selectedLogType.toUpperCase())
              return item;
        });
      }
      if (selectedAgent && filteredLogs && filteredLogs.length > 0) {
        filteredLogs = filteredLogs.filter(
          item => item.agent_id.toUpperCase() === selectedAgent.toUpperCase()
        );
      }
      if (selectedDateFrom && filteredLogs && filteredLogs.length > 0) {
        filteredLogs = filteredLogs.filter(item => {
          const itemDate = new Date(item.time);
          return itemDate >= selectedDateFrom;
        });
      }
      if (selectedDateTo && filteredLogs && filteredLogs.length > 0) {
        filteredLogs = filteredLogs.filter(item => {
          const itemDate = new Date(item.time);
          return itemDate <= selectedDateTo;
        });
      }
      that.data = filteredLogs;
    },

    CheckFetchAgentEvents(check) {
      const that = this;
      if (check) {
        const selectedLogType = that.selectedLogType
          ? that.selectedLogType.ConfigurationKey
          : undefined;
        const selectedAgent = that.selectedAgent
          ? that.selectedAgent.AgentId
          : undefined;
        const selectedDateFrom = that.dateFrom ? that.dateFrom : undefined;
        const selectedDateTo = that.dateTo ? that.dateTo : undefined;
        that.loading = true;
        dataService
          .FetchAgentEvents(
            selectedLogType,
            selectedAgent,
            selectedDateFrom,
            selectedDateTo
          )
          .then(resp => {
            that.loading = false;
            const parsed = JSON.parse(resp);
            that.data = parsed.map(jo => {
              /* eslint-disable */
              jo.agent_id = jo.agentId;
              jo.log_type = jo.logType;
              jo.data = jo.message;
              /* eslint-enable */
              return jo;
            });
            that.logData = that.data;
            that.searchFilter();
          })
          .catch(err => {
            that.loading = false;
          });
      } else that.getLogs();
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    formatViewString(val, length) {
      if (val && val.length > length) return `${val.substring(0, length)}...`;
      return val;
    },
    fromatDate(val) {
      if (val) {
        let date = new Date(val);
        // eslint-disable-next-line
        try {
          date = new Date(`${val} UTC`);
        } catch (e) {}
        return date.toLocaleString();
        // return `${date.getFullYear()}/${String(date.getMonth() + 1).padStart(2, '00')}/${String(date.getDate()).padStart(2, '00')} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;
      }
      return "";
    },
    viewAgentLog(row) {
      const that = this;
      that.dialog = !that.dialog;
      that.dialogData = row;
    },
    focusControl(input) {
      const that = this;
      if (that.$refs[input] && that.$refs[input].isDisabled === false) {
        that.$refs[input].blur();
        that.$refs[input].focus();
      }
    }
  }
};
</script>
